import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import LoadingPopup from "../helpers/loading_component.js";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const EditLeadDecAgg = (props) => {
  const [value, setValue] = useState(props.leadData.decAgg);
  const [loading, setLoading] = useState(false);
  const [banks, setBanks] = useState([]);

  const getData = () => {};

  useEffect(() => {
    getData();
  }, []);

  const editLead = async (e) => {
    if (validatePayment()) {
      setLoading(true);

      var body = {
        leadId: props.leadData.id,
        leadName: props.leadData.name,
        field: "decAgg",
        value: value,
      };

      await fetch("https://apidevkppp.ftpeople.pl/updateLead", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction(
        "Edytowano deklaracje przesłania umowy: " + props.user,
        props.leadData.id
      );

      MySwal.fire({
        icon: "success",
        title: "Edytowano",
        text: "lead",
      }).then(async (result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validatePayment = (e) => {
    if (value.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="mainContainerAddClientContact">
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="inputBox">
            <div className="inputCol_1">
              <label>
                Deklaracja przesłania umowy{" "}
                <span className="requiredStar">*</span>
              </label>
              <select
                style={{ boxSizing: "border-box" }}
                type="text"
                id="name"
                name="name"
                value={value}
                onChange={(e) => {
                  setValue(e.target.value);
                }}
              >
                {!value ? (
                  <>
                    <option key={0} value={0}>
                      Wybierz...
                    </option>
                  </>
                ) : (
                  ""
                )}
                <>
                  <option key={0} value="TAK">
                    TAK
                  </option>
                  <option key={0} value="NIE">
                    NIE
                  </option>
                </>
              </select>
            </div>
          </div>

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editLead}>
              zapisz
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditLeadDecAgg;
